import util from './util/util.js';

const LOG = window.Logger;

export {util, LOG};
